import { useState } from 'react';

function useModalDefault(onInit: () => void, initShow: boolean = false) {
  const [show, setShow] = useState<boolean>(initShow);
  const handleShow = () => {
    onInit();
    setShow(true);
  };
  const handleClose = () => setShow(false);

  return {
    show, handleShow, handleClose,
  };
}

export default useModalDefault;
